// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__o7z2C","header":"MessagesList_header__1R4AZ","chat":"MessagesList_chat__gYE6G"};